
import { ref, defineComponent } from 'vue'
import ServiesSection from '@/views/ServicesSection.vue'
import DollarChart from '@/views/DollarChart.vue'

export default defineComponent({
  name: 'DescriptionComponent',
  components: {
    ServiesSection,
    DollarChart
  },
  setup () {
    const showDollarChart = ref(false)

    function toggleDollarChartVisibility () {
      showDollarChart.value = !showDollarChart.value
    }
    return {
      showDollarChart,
      toggleDollarChartVisibility
    }
  }
})
